import { Link } from '@grammarly/design-system'
import { type useComponentTracking } from '@grammarly/react-component-tracking'
import styles from './InlineAction.module.scss'
import { useCallback } from 'react'

export type Props = {
  readonly onClick: VoidFunction
  readonly label: string
  readonly accessibilityLabel: string
  readonly tracking?: ReturnType<typeof useComponentTracking>
}

/**
 * A clickable inline action component rendered as a link within an ErrorBox.
 */
export function ErrorBoxInlineAction({ onClick, label, accessibilityLabel, tracking }: Props) {
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault()
      tracking?.trackClicked()
      onClick()
    },
    [onClick, tracking],
  )

  return (
    <Link
      data-testid="ErrorBoxActionLink"
      className={styles.errorBoxInlineAction}
      ref={tracking?.trackingRef}
      onClick={handleClick}
      variant="inherit"
      href=""
      accessibilityLabel={accessibilityLabel}
    >
      {label}
    </Link>
  )
}
